// eslint-disable-next-line no-unused-vars
;(function ($) {
	async function init_filters() {
		const Foundation = await import(/* webpackChunkName: "foundation" */ 'foundation-sites/js/foundation.core')
		const OffCanvas = await import(/* webpackChunkName: "offcanvas" */ 'foundation-sites/js/foundation.offcanvas')

		Foundation.Foundation.addToJquery($)
		Foundation.Foundation.plugin(OffCanvas.OffCanvas, 'OffCanvas')
		$(document).foundation()
		$('.location__mobile-filters').removeClass('hide')
	}

	/**
	 * Mobile Filters Manager for Ardent Locations (Refactored Plugin Compatible)
	 * Works with the refactored plugin's state management
	 */
	class MobileFiltersManager {
		constructor($container, pluginInstance) {
			this.$container = $container
			this.plugin = pluginInstance
			this.maxFilter = this.plugin.settings.maxVisibleFilters || 5
			this.cache = {}
		}

		/**
		 * Initialize mobile filters
		 */
		init() {
			if (!this.validate()) {
				return this
			}

			this.setupOffCanvasStructure()
			this.buildMobileFilters()
			this.createFilterToggleButton()
			this.initializeFoundation()
			this.setupEventListeners()

			// Sync with URL (which populates state.activeFilters)
			this.plugin.syncWithURL(false)

			// Call external init_filters if it exists
			if (typeof init_filters === 'function') {
				init_filters()
			}

			return this
		}

		/**
		 * Validate plugin instance and settings
		 */
		validate() {
			if (!this.plugin || !this.plugin.state || !this.plugin.settings) {
				console.warn('MobileFiltersManager: Invalid refactored plugin instance')
				return false
			}

			if (!this.plugin.settings.filters || Object.keys(this.plugin.settings.filters).length === 0) {
				console.warn('MobileFiltersManager: No filters configured')
				return false
			}

			return true
		}

		/**
		 * Setup off-canvas wrapper structure
		 */
		setupOffCanvasStructure() {
			this.$container.addClass('off-canvas-wrapper')
			$('.location__wrapper').addClass('off-canvas-content')

			const $overlay = $('<div class="js-off-canvas-overlay is-overlay-fixed is-closable"></div>')
			this.$container.append($overlay)

			// Setup overlay click to close
			$overlay.on('click', () => {
				this.closeOffCanvas()
			})

			this.cache.$overlay = $overlay
		}

		/**
		 * Build all mobile filters
		 */
		buildMobileFilters() {
			const filtersFrag = document.createDocumentFragment()

			Object.values(this.plugin.settings.filters).forEach(filter => {
				if (filter.enabled) {
					const filterElement = this.createFilter(filter)
					filtersFrag.appendChild(filterElement)
				}
			})

			const mobileFilters = this.createMobileFiltersContainer()
			mobileFilters.appendChild(filtersFrag)

			this.addShowResultsButtons(mobileFilters)

			this.$container.append(mobileFilters)
			this.cache.$mobileFilters = $(mobileFilters)
		}

		/**
		 * Create mobile filters container
		 */
		createMobileFiltersContainer() {
			const container = document.createElement('div')
			container.classList.add('location__mobile-filters', 'off-canvas-absolute', 'hide')
			container.setAttribute('data-off-canvas', '')
			container.setAttribute('id', 'location-filters-canvas')
			container.setAttribute('data-content-scroll', 'true')
			return container
		}

		/**
		 * Create a single filter section
		 */
		createFilter(filter) {
			const el = document.createElement('fieldset')
			el.classList.add('location-filters__' + filter.dataFilter, 'location-filter')

			const filterFrag = document.createDocumentFragment()

			// Add legend element for the screen reader
			const legend = document.createElement('legend')
			legend.classList.add('screen-reader-text')
			legend.appendChild(document.createTextNode(filter.title))
			filterFrag.appendChild(legend)

			// Add header
			const header = this.createFilterHeader(filter)
			filterFrag.appendChild(header)

			// Add filter list
			const list = this.createFilterList(filter)
			filterFrag.appendChild(list)

			// Add show more toggle if needed
			if (filter.data.length > this.maxFilter) {
				const toggle = this.createShowMoreToggle(filter)
				filterFrag.appendChild(toggle)
			}

			el.appendChild(filterFrag)
			return el
		}

		/**
		 * Create filter header with title and clear button
		 */
		createFilterHeader(filter) {
			const filterHeader = document.createElement('div')
			filterHeader.classList.add('location-filters__heading')
			filterHeader.setAttribute('id', 'mobile-' + filter.dataFilter + '-heading')

			const filterHeading = document.createElement('h5')
			filterHeading.setAttribute('aria-hidden', 'true')
			filterHeading.appendChild(document.createTextNode(filter.title))
			filterHeader.appendChild(filterHeading)

			const headingFilterClear = document.createElement('span')
			headingFilterClear.classList.add('filter__clear', 'hide')
			headingFilterClear.dataset.filter = filter.dataFilter
			headingFilterClear.appendChild(document.createTextNode('Clear'))
			headingFilterClear.addEventListener('click', () => {
				// Call refactored plugin's clearFilter method (updates state automatically)
				this.plugin.clearFilter(headingFilterClear.dataset.filter, false)
				// Sync mobile UI to match desktop reordering
				this.syncFromState()
			})
			filterHeader.appendChild(headingFilterClear)

			return filterHeader
		}

		/**
		 * Create filter list with radio buttons
		 */
		createFilterList(filter) {
			const filterList = document.createElement('div')
			filterList.classList.add('location-filters__filters')

			filter.data.forEach((item, index) => {
				const itemInputField = this.createFilterItem(filter, item, index)
				filterList.appendChild(itemInputField)
			})

			return filterList
		}

		/**
		 * Create individual filter item
		 */
		createFilterItem(filter, item, index) {
			const itemId = 'mobile-' + filter.dataFilter + '-' + item.key

			// Create label wrapper
			const itemInputField = document.createElement('label')
			itemInputField.htmlFor = itemId
			itemInputField.classList.add(filter.dataFilter + '-filter', 'location-filters__filter')

			// Create radio input
			const itemRadio = document.createElement('input')
			itemRadio.type = 'radio'
			itemRadio.name = 'mobile-' + filter.dataFilter
			itemRadio.value = item.key
			itemRadio.id = itemId

			// Check if this filter is active in state
			const isActive = this.plugin.state.activeFilters[filter.dataFilter] === item.key
			itemRadio.checked = isActive

			// Add change event
			itemRadio.addEventListener('change', () => {
				const filterName = itemRadio.name.replace('mobile-', '')
				// Call refactored plugin's setFilter method (updates state automatically)
				this.plugin.setFilter(filterName, itemRadio.value, false)
				// Sync mobile UI to match desktop reordering
				this.syncFromState()
			})

			// Create label text
			const itemLabel = document.createElement('span')
			itemLabel.appendChild(document.createTextNode(item.value))

			itemInputField.appendChild(itemRadio)
			itemInputField.appendChild(itemLabel)

			// Handle visibility
			if (index >= this.maxFilter) {
				itemInputField.setAttribute('data-show', 'more')
				itemInputField.classList.add('hide')
			}

			itemInputField.setAttribute('data-filter-visible', 'show')

			return itemInputField
		}

		/**
		 * Create show more/less toggle
		 */
		createShowMoreToggle(filter) {
			const itemShowMore = document.createElement('div')
			itemShowMore.classList.add('show-more-' + filter.dataFilter, 'location-filters__toggle')

			const itemShowMoreLink = document.createElement('a')
			itemShowMoreLink.appendChild(document.createTextNode('Show More'))
			itemShowMoreLink.setAttribute('data-toggle', 'more')
			itemShowMoreLink.addEventListener('click', e => {
				// Call refactored plugin's toggleFilterVisibility method
				this.plugin.toggleFilterVisibility(e, itemShowMoreLink, 'mobile-' + filter.dataFilter)
			})

			itemShowMore.appendChild(itemShowMoreLink)
			return itemShowMore
		}

		/**
		 * Sync clear button visibility based on state
		 */
		syncClearButtonState(filterName) {
			const hasActiveFilter = filterName in this.plugin.state.activeFilters
			const $clearBtn = $(`.location__mobile-filters .filter__clear[data-filter="${filterName}"]`)

			if (hasActiveFilter) {
				$clearBtn.removeClass('hide')
			} else {
				$clearBtn.addClass('hide')
			}
		}

		/**
		 * Add "Show Results" buttons at top and bottom
		 */
		addShowResultsButtons(container) {
			const createButton = () => {
				const button = document.createElement('button')
				button.classList.add('button', 'filter', 'hide-for-medium')
				button.appendChild(document.createTextNode('Show Results'))
				button.addEventListener('click', () => {
					this.closeOffCanvas()
					this.scrollToResults()
				})
				return button
			}

			// Add to top
			container.insertBefore(createButton(), container.firstChild)

			// Add to bottom
			container.appendChild(createButton())
		}

		/**
		 * Create filter toggle button
		 */
		createFilterToggleButton() {
			const $button = $('<button>Filters</button>')
				.addClass('button filter hide-for-medium')
				.attr('data-toggle', 'location-filters-canvas')
				.on('click', () => {
					this.openOffCanvas()
				})

			$('.location__listings').prepend($button)
			this.cache.$filterToggle = $button
		}

		/**
		 * Setup event listeners for plugin changes
		 */
		setupEventListeners() {
			// Listen for desktop filter changes and sync mobile
			this.$container.on('filterChanged', () => {
				this.syncFromState()
			})

			this.$container.on('filterCleared', () => {
				this.syncFromState()
			})

			this.$container.on('filtersCleared', () => {
				this.syncFromState()
			})

			// Also sync when mobile panel opens
			if (this.cache.$mobileFilters) {
				this.cache.$mobileFilters.on('opened.zf.offcanvas', () => {
					this.syncFromState()
				})
			}
		}

		/**
		 * Initialize Foundation off-canvas
		 */
		initializeFoundation() {
			if (typeof Foundation !== 'undefined' && this.cache.$mobileFilters) {
				this.cache.$mobileFilters.foundation()
			}
		}

		/**
		 * Open off-canvas menu
		 */
		openOffCanvas() {
			this.cache.$overlay.addClass('is-visible')

			if (this.cache.$mobileFilters && typeof Foundation !== 'undefined') {
				this.cache.$mobileFilters.foundation('open')
			}
		}

		/**
		 * Close off-canvas menu
		 */
		closeOffCanvas() {
			this.cache.$overlay.removeClass('is-visible')

			if (this.cache.$mobileFilters && typeof Foundation !== 'undefined') {
				this.cache.$mobileFilters.foundation('close')
			}
		}

		/**
		 * Scroll to results section
		 */
		scrollToResults() {
			// Use refactored plugin's scroll method
			this.plugin.scrollToStats()
		}

		/**
		 * Sync mobile filters from plugin state
		 * Call this method to update mobile UI when desktop filters change
		 */
		syncFromState() {
			Object.values(this.plugin.settings.filters).forEach(filter => {
				if (!filter.enabled) return

				const activeValue = this.plugin.state.activeFilters[filter.dataFilter]
				const filteredLocations = this.plugin.getFilteredLocations()

				// Categorize filters into available and unavailable (same logic as desktop)
				const available = []
				const unavailable = []

				if (activeValue) {
					// If filter is active, it's available, rest are unavailable
					filter.data.forEach(item => {
						const mobileRadio = document.getElementById(`mobile-${filter.dataFilter}-${item.key}`)
						if (mobileRadio) {
							if (item.key === activeValue) {
								available.push(mobileRadio)
							} else {
								unavailable.push(mobileRadio)
							}
						}
					})
				} else {
					// No active filter, categorize based on location availability
					filter.data.forEach(item => {
						const hasLocations = filteredLocations.some(location => {
							const filterValue = location[filter.dataFilter]
							return Array.isArray(filterValue)
								? filterValue.includes(item.key)
								: filterValue === item.value
						})

						const mobileRadio = document.getElementById(`mobile-${filter.dataFilter}-${item.key}`)
						if (mobileRadio) {
							if (hasLocations) {
								available.push(mobileRadio)
							} else {
								unavailable.push(mobileRadio)
							}
						}
					})
				}

				// Get the mobile filter container
				const $container = $(
					`.location__mobile-filters .location-filters__${filter.dataFilter} .location-filters__filters`
				)

				if (!$container.length) return

				// Get show more state
				const $showMoreLink = $(`.location__mobile-filters .show-more-${filter.dataFilter} a`)
				const showMore = $showMoreLink.length ? $showMoreLink.data('toggle') : 'more'

				// Shared counter for available + unavailable (same as desktop)
				let filterLoop = 0

				// Render available filters first (moves them to top)
				available.forEach(radio => {
					const $radio = $(radio)
					const $label = $radio.parent()

					$radio.prop('disabled', false).prop('checked', radio.value === activeValue)
					$label.removeClass('disabled').removeClass('fadeIn').removeClass('fadeOut')

					// Apply visibility based on shared counter
					if (filterLoop >= this.maxFilter) {
						$label.attr('data-show', showMore)
						$label.toggleClass('hide', showMore === 'more')
					} else {
						$label.attr('data-show', '').removeClass('hide')
					}

					$container.append($label) // Move to container (reorders to top)
					filterLoop++
				})

				// Render unavailable filters (moves them after available)
				unavailable.forEach(radio => {
					const $radio = $(radio)
					const $label = $radio.parent()

					$radio.prop('disabled', true).prop('checked', false)
					$label.addClass('disabled').removeClass('fadeIn').removeClass('fadeOut')

					// Apply visibility based on shared counter
					if (filterLoop >= this.maxFilter) {
						$label.attr('data-show', showMore)
						$label.toggleClass('hide', showMore === 'more')
					} else {
						$label.attr('data-show', '').removeClass('hide')
					}

					$container.append($label) // Move to container (reorders after available)
					filterLoop++
				})

				// Update clear button visibility
				this.syncClearButtonState(filter.dataFilter)
			})
		}

		/**
		 * Get current active filters from state
		 */
		getActiveFilters() {
			return { ...this.plugin.state.activeFilters }
		}

		/**
		 * Clean up and destroy
		 */
		destroy() {
			// Remove plugin event listeners
			this.$container.off('filterChanged')
			this.$container.off('filterCleared')
			this.$container.off('filtersCleared')

			// Remove off-canvas event listeners
			if (this.cache.$mobileFilters) {
				this.cache.$mobileFilters.off('opened.zf.offcanvas')
			}

			// Remove event listeners
			if (this.cache.$filterToggle) {
				this.cache.$filterToggle.off().remove()
			}

			if (this.cache.$overlay) {
				this.cache.$overlay.off().remove()
			}

			if (this.cache.$mobileFilters) {
				// Remove all event listeners from children
				this.cache.$mobileFilters.find('*').off()
				this.cache.$mobileFilters.remove()
			}

			// Remove classes
			this.$container.removeClass('off-canvas-wrapper')
			$('.location__wrapper').removeClass('off-canvas-content')

			// Clear cache
			this.cache = {}
		}
	}

	/**
	 * Initialize mobile filters
	 */
	function initArdentMobileFilters() {
		const $container = $('.wp-block-ardent-health-locations')

		if (!$container.length) {
			console.warn('Ardent Locations container not found')
			return null
		}

		const pluginInstance = $container.data('ardentLocations')

		if (!pluginInstance) {
			console.warn('Ardent Locations plugin not initialized')
			return null
		}

		// Validate it's the refactored version
		if (!pluginInstance.state || typeof pluginInstance.state.activeFilters === 'undefined') {
			console.error('MobileFiltersManager requires the REFACTORED plugin version with state management')
			return null
		}

		const mobileFilters = new MobileFiltersManager($container, pluginInstance)
		mobileFilters.init()

		// Store instance for later access
		$container.data('ardentMobileFilters', mobileFilters)

		return mobileFilters
	}

	// Add aria-label to search field
	$('.wp-block-ardent-health-locations').on('locationsLoaded', function () {
		initArdentMobileFilters()
		$('.tt-hint').attr('aria-label', 'Location Search Hint')
	})
})(jQuery)
